import { DText, FlexCenter, FlexEnd, FlexStart, Padding } from "../../styles/CommonStyles";
import { useSocketContent } from "../../contexts/socket-content"
import { formatNumber } from "../../utils/common";
import { DownArrow, OrdersScrollWrap, UpArrow } from "../../styles/OrderBookStyles";
import {useMainContext} from "../../contexts/main";
import {useTradePrice} from "../../contexts/trade-price";
import {useEffect, useState} from "react";
import {concatOrders} from "../../utils/orderBook";
import {MOBILE_SIZE} from "../../constants/common";
import {useWindowSize} from "../../hooks/common/useWindowSize";


const TypeOrders = ({ type }) => {

    const { width } = useWindowSize()
    const { buyOrders, sellOrders, trades } = useSocketContent()
    const { market } = useMainContext()
    const { setTradePrice } = useTradePrice()

    const [_buyOrders, setBuyOrders] = useState(null)
    const [_sellOrders, setSellOrders] = useState(null)

    const onOrderClicked = (type, price) => {
        if (market.pair === "irt") {
            setTradePrice(state => ({ ...state, [type === "buy" ? "sell" : "buy"]: price, type }))
        } else {
            setTradePrice(state => ({ ...state, value: price, type }))
        }
    }

    useEffect(() => {
        if (buyOrders) {
            setBuyOrders(concatOrders(buyOrders))
        }
    }, [buyOrders])

    useEffect(() => {
        if (sellOrders) {
            setSellOrders(concatOrders(sellOrders))
        }
    }, [sellOrders])

    return (
        <>
            <FlexStart>
                <Padding padding="15px 0">
                    {trades?.length ?
                        <>
                            <DText>{formatNumber(trades[0].priceUnit)}</DText>
                            <Padding padding="0 6px">
                                {
                                    trades[0].type === "buy" ?
                                        <UpArrow size={20} />
                                        :
                                        <DownArrow size={20} />
                                }
                            </Padding>
                        </>
                        : <DText>0</DText>
                    }
                </Padding>
            </FlexStart>
            <OrdersScrollWrap >
                {(type === "buy" ? _buyOrders : _sellOrders)?.map(order => (
                    <FlexCenter
                        key={order._id}
                        style={{ cursor: "pointer" }}
                        onClick={() => onOrderClicked(type, order.priceUnit)}
                    >
                        <Padding padding="3px 0">
                            <FlexStart width={width > MOBILE_SIZE ? "30%" : "50%"}>
                                <DText type="number" color={order.type === "buy" ? "#1ce087" : "#f84960"}>
                                    {formatNumber(order.priceUnit)}
                                </DText>
                            </FlexStart>
                            <FlexEnd type="number" width={width > MOBILE_SIZE ? "30%" : "50%"}>
                                <DText>
                                    {formatNumber(order.amount, 6)}
                                </DText>
                            </FlexEnd>
                            {width > MOBILE_SIZE &&
                                <FlexEnd type="number" width="40%">
                                    <DText>
                                        {formatNumber(order.price)}
                                    </DText>
                                </FlexEnd>
                            }
                        </Padding>
                    </FlexCenter>
                ))}
            </OrdersScrollWrap>
        </>
    )

}


export default TypeOrders;